'use client';

import { c as _c } from "react/compiler-runtime";
import type { ModalShellProps, SheetShellProps } from '@sizzlenz/shared-frontend/ui';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

/**
 * Binds the shared modal/sheet system to this app's shadcn primitives.
 * Registered through `SharedUIProvider` in `@/components/Providers`.
 */

export function ModalShell(t0) {
  const $ = _c(14);
  const {
    open,
    onOpenChange,
    title,
    description,
    className,
    showCloseButton,
    fullscreenOnMobile,
    preventAutoFocus,
    children
  } = t0;
  const t1 = showCloseButton ?? true;
  const t2 = fullscreenOnMobile ?? false;
  const t3 = preventAutoFocus ? _temp : undefined;
  let t4;
  if ($[0] !== description || $[1] !== title) {
    t4 = (title || description) && <DialogHeader>{title && <DialogTitle>{title}</DialogTitle>}{description && <DialogDescription>{description}</DialogDescription>}</DialogHeader>;
    $[0] = description;
    $[1] = title;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== className || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <DialogContent className={className} showCloseButton={t1} fullscreenOnMobile={t2} onOpenAutoFocus={t3}>{t4}{children}</DialogContent>;
    $[3] = children;
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t5) {
    t6 = <Dialog open={open} onOpenChange={onOpenChange}>{t5}</Dialog>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(e) {
  return e.preventDefault();
}
export function SheetShell(t0) {
  const $ = _c(13);
  const {
    open,
    onOpenChange,
    className,
    title,
    headerActions,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <SheetTitle className="flex-1">{title}</SheetTitle>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== headerActions || $[3] !== t1) {
    t2 = <SheetHeader><div className="flex items-center gap-2">{headerActions}{t1}</div></SheetHeader>;
    $[2] = headerActions;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== className || $[7] !== t2) {
    t3 = <SheetContent className={className}>{t2}{children}</SheetContent>;
    $[5] = children;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onOpenChange || $[10] !== open || $[11] !== t3) {
    t4 = <Sheet open={open} onOpenChange={onOpenChange}>{t3}</Sheet>;
    $[9] = onOpenChange;
    $[10] = open;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}